import { query_bed_list } from '@/api/mjstore-model';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import cacheRemoteSelect from '@/components/FormRender/utils';

const org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
const search_config: any = {
  model: {
    org_id: org?.id,
    is_active: true,
    pageSize: 2000,
  },
  watch: ['shop_id'],
};

export default (modelType?: string) => {
  return {
    getData: cacheRemoteSelect(query_bed_list, modelType),
    searchConfig: search_config,
  };
};
